<script lang="ts" setup>
import CalculationBudgetTable from '@/components/calculation-budget/calculation-budget-table.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <h1 class="is-size-4 mb-4">{{ t('calculationBudget.title') }}</h1>
  <calculation-budget-table></calculation-budget-table>
</template>

<style scoped lang="scss"></style>
